import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetCatalogProductQueryOptions } from "@/requests/gen/react-query/catalog-product";
import CatalogProductCreateForm from "../-form";
import { CatalogCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/catalog-product/$catalogProductId/edit",
)({
  loader: ({ context: { queryClient }, params: { catalogProductId } }) =>
    queryClient.ensureQueryData(
      getGetCatalogProductQueryOptions(numericId(catalogProductId)),
    ),
  component: CatalogProductEditPage,
});

function CatalogProductEditPage() {
  const { catalogProductId } = Route.useParams();
  const { data: catalogProduct } = useSuspenseQuery(
    suspenseOptions(
      getGetCatalogProductQueryOptions(numericId(catalogProductId)),
    ),
  );

  return (
    <div>
      <title>
        {`Edit ${catalogProduct?.product_base.name || "Catalog Product"} - Legrande Health Portal`}
      </title>
      <CatalogCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Catalog Product</CardTitle>
          <CardDescription>
            Enter catalog product details below.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {catalogProduct && (
            <CatalogProductCreateForm catalogProduct={catalogProduct} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
